import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Usuário Externo',
    path: '/transporte/trausuarioadicional',
    name: 'trausuarioadicional',
    component: () => import('@/views/transporte/trausuarioadicional/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.USUARIOSEXTERNOSDOTRANSPORTENOVO_MENU_1100400299],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Usuário Externo',
    parent: 'trausuarioadicional',
    path: '/transporte/trausuarioadicional/cadastro/:id?',
    name: 'trausuarioadicional-create',
    component: () => import('@/views/transporte/trausuarioadicional/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.USUARIOSEXTERNOSDOTRANSPORTENOVO_MENU_1100400299],
    },
    goesToMenu: false,
  },
];
